"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallPagination = exports.LargePagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ = require("../");

var _helpers = require("../../helpers");

var _svgs = require("../../svgs");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LargePagination = function LargePagination(props) {
  var _props$pageCursors = props.pageCursors,
      around = _props$pageCursors.around,
      first = _props$pageCursors.first,
      last = _props$pageCursors.last,
      previous = _props$pageCursors.previous,
      onClick = props.onClick,
      onNext = props.onNext,
      hasNextPage = props.hasNextPage;
  return _react.default.createElement(_.Flex, {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "baseline",
    mr: -1
  }, first && _react.default.createElement("div", null, renderPage(first, onClick), _react.default.createElement(PageSpan, {
    mx: 0.5
  })), around.map(function (pageInfo) {
    return renderPage(pageInfo, onClick);
  }), last && _react.default.createElement("div", null, _react.default.createElement(PageSpan, {
    mx: 0.5
  }), renderPage(last, onClick)), _react.default.createElement(_.Box, {
    ml: 4
  }, _react.default.createElement(PrevButton, {
    disabled: !previous,
    onClick: function onClick() {
      if (previous) {
        props.onClick(previous.cursor, previous.page);
      }
    }
  }), _react.default.createElement(NextButton, {
    disabled: !hasNextPage,
    onClick: function onClick() {
      return onNext();
    }
  })));
};

exports.LargePagination = LargePagination;
LargePagination.displayName = "LargePagination";

var SmallPagination = function SmallPagination(props) {
  var previous = props.pageCursors.previous,
      onClick = props.onClick,
      onNext = props.onNext,
      hasNextPage = props.hasNextPage;
  return _react.default.createElement(_.Flex, {
    flexDirection: "row",
    width: "100%"
  }, _react.default.createElement(PrevNextFlex, {
    className: !previous ? "disabled" : null,
    width: "50%",
    pr: 0.5
  }, _react.default.createElement(ButtonWithBorder, {
    alignItems: "center",
    justifyContent: "flex-start",
    pl: 1,
    onClick: function (_onClick) {
      function onClick() {
        return _onClick.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick.toString();
      };

      return onClick;
    }(function () {
      if (previous) {
        onClick(previous.cursor, previous.page);
      }
    })
  }, _react.default.createElement(_svgs.ChevronIcon, {
    direction: "left"
  }))), _react.default.createElement(PrevNextFlex, {
    className: !hasNextPage ? "disabled" : null,
    width: "50%",
    pl: 0.5
  }, _react.default.createElement(ButtonWithBorder, {
    onClick: function onClick() {
      return onNext();
    },
    alignItems: "center",
    justifyContent: "flex-end",
    pr: 1
  }, _react.default.createElement(_svgs.ChevronIcon, {
    direction: "right"
  }))));
};

exports.SmallPagination = SmallPagination;
SmallPagination.displayName = "SmallPagination";
var ButtonWithBorder = (0, _styledComponents.default)(_.Flex).withConfig({
  displayName: "Pagination__ButtonWithBorder",
  componentId: "sc-1r2jw01-0"
})(["border:", ";border-color:", ";border-radius:3px;width:100%;height:", "px;cursor:pointer;"], function (props) {
  return props.theme.borders[1];
}, (0, _helpers.color)("black10"), (0, _helpers.space)(4));

var PageSpan = function PageSpan(_ref) {
  var mx = _ref.mx;
  return _react.default.createElement(_.Sans, {
    size: "3",
    display: "inline",
    mx: mx,
    color: "black30"
  }, "...");
};

PageSpan.displayName = "PageSpan";

var renderPage = function renderPage(pageCursor, onClick) {
  var cursor = pageCursor.cursor,
      isCurrent = pageCursor.isCurrent,
      page = pageCursor.page;
  return _react.default.createElement(Page, {
    onClick: function (_onClick2) {
      function onClick() {
        return _onClick2.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick2.toString();
      };

      return onClick;
    }(function () {
      return onClick(cursor, page);
    }),
    num: page,
    active: isCurrent,
    key: cursor + page
  });
};

renderPage.displayName = "renderPage";

var Page = function Page(_ref2) {
  var num = _ref2.num,
      onClick = _ref2.onClick,
      props = _objectWithoutProperties(_ref2, ["num", "onClick"]);

  return _react.default.createElement(Button, _extends({}, props, {
    onClick: function (_onClick3) {
      function onClick() {
        return _onClick3.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick3.toString();
      };

      return onClick;
    }(function () {
      return onClick();
    })
  }), _react.default.createElement(_.Sans, {
    size: "3",
    weight: "medium",
    display: "inline"
  }, num));
};

Page.displayName = "Page";
var activeButton = (0, _styledComponents.css)(["background:", ";border-radius:2px;border:0;"], (0, _helpers.color)("black5"));

var Button = _styledComponents.default.button.attrs({}).withConfig({
  displayName: "Pagination__Button",
  componentId: "sc-1r2jw01-1"
})(["cursor:pointer;width:min-content;height:25px;background:transparent;border:0;outline:0;", ";&:hover{", ";}"], function (p) {
  return p.active && activeButton;
}, activeButton);

var PrevButton = function PrevButton(_ref3) {
  var onClick = _ref3.onClick,
      disabled = _ref3.disabled;
  return _react.default.createElement(PrevNextContainer, {
    className: disabled ? "disabled" : null
  }, _react.default.createElement(_.Sans, {
    size: "3",
    weight: "medium",
    display: "inline",
    mx: 0.5
  }, _react.default.createElement("a", {
    onClick: function (_onClick4) {
      function onClick() {
        return _onClick4.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick4.toString();
      };

      return onClick;
    }(function () {
      return onClick();
    }),
    className: "noUnderline"
  }, _react.default.createElement(_svgs.ChevronIcon, {
    direction: "left",
    top: (0, _helpers.space)(0.5)
  }), " Prev")));
};

PrevButton.displayName = "PrevButton";

var NextButton = function NextButton(_ref4) {
  var onClick = _ref4.onClick,
      disabled = _ref4.disabled;
  return _react.default.createElement(PrevNextContainer, {
    className: disabled ? "disabled" : null
  }, _react.default.createElement(_.Sans, {
    size: "3",
    weight: "medium",
    display: "inline",
    mx: 0.5
  }, _react.default.createElement("a", {
    onClick: function (_onClick5) {
      function onClick() {
        return _onClick5.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick5.toString();
      };

      return onClick;
    }(function () {
      return onClick();
    }),
    className: "noUnderline"
  }, "Next ", _react.default.createElement(_svgs.ChevronIcon, {
    direction: "right",
    top: (0, _helpers.space)(0.5)
  }))));
};

NextButton.displayName = "NextButton";

var PrevNextContainer = _styledComponents.default.span.withConfig({
  displayName: "Pagination__PrevNextContainer",
  componentId: "sc-1r2jw01-2"
})(["&.disabled{opacity:0.1;}"]);

var PrevNextFlex = (0, _styledComponents.default)(_.Flex).withConfig({
  displayName: "Pagination__PrevNextFlex",
  componentId: "sc-1r2jw01-3"
})(["&.disabled{opacity:0.1;}"]); // Tests

ButtonWithBorder.displayName = "ButtonWithBorder";
PrevButton.displayName = "PrevButton";
NextButton.displayName = "NextButton";
//# sourceMappingURL=Pagination.js.map